import { render, staticRenderFns } from "./AdminCoownersList.vue?vue&type=template&id=e3a2787c"
import script from "./AdminCoownersList.vue?vue&type=script&lang=ts"
export * from "./AdminCoownersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports